'use strict';

exports = module.exports = require('./lib/memoizer')['default'];
exports['default'] = exports;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-intl/~/intl-format-cache/index.js
 ** module id = 37
 ** module chunks = 0
 **/